import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ok-popup',
  templateUrl: './ok-popup.component.html',
  styleUrls: ['./ok-popup.component.scss']
})

export class OkPopupComponent implements OnInit {

  @Input()  messageHeader: string;
  @Input()  popupText1: string;
  @Input()  popupText2: string;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

  ok(){
    this.activeModal.dismiss();
  }

}
